import { render, staticRenderFns } from "./NoBodyMedia.vue?vue&type=template&id=3025fd86"
import script from "./NoBodyMedia.vue?vue&type=script&lang=js"
export * from "./NoBodyMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports